@use '@lib/assets/styles/main.scss' as *;

.accessListItem {
  border-radius: 8px;
  border: 1px solid $gray10;
  background: $gray10;
  & + .accessListItem {
    margin-top: 8px;
  }
}

.accessListItemContent {
  display: grid;
  grid-template-columns: minmax(0, auto) min-content;
  grid-column-gap: 24px;
  grid-row-gap: 12px;
  padding: 16px;
  & + .accessListItemContent {
    border-top: 1px solid $gray100;
  }
  &.accessListItemContentRow {
    align-items: center;
    .accessListItemTitleWrap {
      grid-column: unset;
    }
  }
  .accessListItemField {
    padding: 0;
    margin-left: -12px;
    margin-right: -12px;
    & > * + * {
      margin-top: 16px;
    }
  }
  .accessListItemTitleWrap {
    grid-column: 1 / 3;
  }
}

.accessListItemFieldRow {
  padding: 0 12px;
  display: flex;
  align-items: center;
  white-space: nowrap;
  min-height: 40px;
}

.accessListItemFieldRowBig {
  min-height: 56px;
}

.accessListItemTitleWrap {
  display: flex;
}

.accessListItemTitle {
  padding-right: 20px;
  position: relative;
}

.accessListItemTitleInfo {
  position: absolute;
  top: 50%;
  right: 0;
  transform: translateY(-50%);
  color: $gray400;
  cursor: pointer;
  & * {
    display: block;
  }
}
